






import Vue from 'vue';

export default Vue.extend({
  name: "PoolMain2d",
  data: () => {
    return {};
  },
});
